module.exports = __webpack_public_path__ + "01_short_black.321fe063.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/01_short_black.png
// module id = 7i1a
// module chunks = 0